// extracted by mini-css-extract-plugin
export var legends = "Legends_legends__tyDyA";
export var items = "Legends_items__HNsyb";
export var rotate = "Legends_rotate__Thigv";
export var dotty = "Legends_dotty__u9PBG";